export default "__VITE_ASSET__b8411f5e__"